import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Input,
  Segment,
} from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { Image } from 'semantic-ui-react';
import * as Yup from 'yup';
import { observer } from 'mobx-react-lite';
import {
  ReceivingDelivery,
  ReceivingDeliveryInitialdata,
} from './../../../app/models/ReceivingDelivery';
import { v4 as uuid } from 'uuid';
import CameraModal from '../../../app/common/modals/CameraModal';
import MyTextInput from '../../../app/common/form/MyTextInput';
import { Formik } from 'formik';
import PackageReceiptPrintView from './PackageReceiptPrintView';
import {
  FileUploadInterface,
  LocalUploadInterface,
} from '../../../app/models/Profile';
import ImageTag from '../../../features/Profile/RenderImage';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import agent from '../../../app/api/agent';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { read, utils } from 'xlsx';
import { addItemGroupRes } from '../../../app/api/types';
import {
  Communication,
  TemplateSubTasks,
  TemplateTask,
  WorkflowElement,
  WorkflowOptions,
  tempApi,
} from '../../../app/models/template';
import { TemplateSubTaskType } from '../../Settings/WorkflowSettings/autoRejectSetting/type';
import Papa from 'papaparse';
import { runInAction } from 'mobx';
import MultiSectionForm from './HFCRegister';
import TitleCreate from '../../Dashboard/PCPL/CGRegister'
import { initialPostFilteredItemDetails } from '../../../app/models/metaDataConfig';
function DashboardReceivingDeliveryForm() { 
  const {
    dashboardStore: {
      dashboard,
      updateCreateOrderTemplate,
      setRegisterUrlResponse,
      setcamImageBase64,
      setOpenCameraModal,
      updateCountOrderMenu,
      setDisaptchCalled,
    },
    receivingdeliveryStore,
    modalStore,
    userStore,
    commonStore,
    userStore: { user },
    metaDataStore: { WorkflowMetadataHandler },
    TemplateStore: { loadTemplateIdForCR, selectedTemplate },
    viewStore:{ NFAIReportRoleBasedUserList }
  } = useStore();
  const {
    selectedReceivingDelivery,
    createReceivingDelivery,
    updateReceivingDelivery,
    loadReceivingDelivery,
    setRecevindDeliveryAsUndefined,
    deleteFile,
    loadReceivingsDeliveriesPagination,
    registerScanData,
    addItemGroupAcquisition,
    createItemAcquisition,
    registerScanned,
    updateDashboardCountNFAI,
  } = receivingdeliveryStore;
  const { hfcCustomerChanges, devEnv } = commonStore;
  const [camImage, setCamImage] = useState<FileUploadInterface[]>([]);
  const [openCamera, setCameraOpen] = useState(false);
  // for creating a new value
  const [createNewReceivingDelivery, setcreateNewReceivingDelivery] =
    useState<ReceivingDelivery>(ReceivingDeliveryInitialdata);
  const [dateString, setDateString] = useState<string>('');
  const [editDateClicked, setEditDateClicked] = useState(false);
  const [receivingTitle, setReceivingTitle] = useState<string>('');
  const [itemGroupsNFAI, setItemGroupsNFAI] = useState<string[]>([]);
  const [finalSaveEditDate, setFinalEditDate] = useState('');
  const [csvDataErr, setCsvDataErr] = useState('Kindly upload Excel document');
  const [currentTaskDetails, setCurrentTaskDetails] = useState<{
    currentTask: string;
    currentSubTask: string;
    activeTaskCount: number;
  }>({
    currentTask: '',
    currentSubTask: '',
    activeTaskCount: 0,
  });
  const [metadataFromExcel, setMetadataFromExcel] = useState<any>({});
  const [NFAILoder,setNFAILoader] = useState<boolean>(false);
  const [NFIACondition,setNFIACondition] = useState<boolean>(false);



  useEffect(() => {
    setCamImage(dashboard.camImageUrl);
    // eslint-disable-next-line
  }, [dashboard.camImageUrl]);

  useEffect(() => {
    ////--------------------------------------------> On Edit
    const getDate = new Date().toISOString().slice(0, 10).split('-'); //create an array
    const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; //setting the date time
    setDateString(_date); //setting the date time

    setFinalEditDate(new Date().toISOString()); //setting time with date
  }, []);

  useEffect(() => {
    // updating
    if (selectedReceivingDelivery?.id !== undefined) {
      const newArr = {
        ...selectedReceivingDelivery,
      };
      setcreateNewReceivingDelivery(newArr);
      setRegisterUrlResponse(newArr.files);
      setCamImage(newArr.files);
      //////////////// this  date is only for view
      const getDate = newArr.date.slice(0, 10).split('-'); //create an array
      const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; //setting the date time
      setDateString(_date); //setting the date time

      //for Refernce
      setFinalEditDate(selectedReceivingDelivery.date);
    }
    // eslint-disable-next-line
  }, [selectedReceivingDelivery]);

  const handleDateChange = (e: any) => {
    //
    const getDate = new Date(e.target.value)
      .toISOString()
      .slice(0, 10)
      .split('-'); //create an array
    const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; //setting the date time

    setDateString(_date);

    let getTime = new Date().toISOString().split('T')[1];
    let dateValue = e.target.value;
    setTimeout(() => {
      setFinalEditDate(dateValue + 'T' + getTime); //setting time with date
      setEditDateClicked(false);
    }, 2000);
  };

  useEffect(() => {
    if (selectedTemplate && selectedTemplate.tasks.length > 0) {
      if(userStore.user?.customerName === 'NFAIReport'){
      const activeTaskTemp = selectedTemplate?.tasks;
      const tempCurrentTaskData = [];
      const tempCurrentSubTaskData = [];
      let firstTask = '';
      let firstSubTask = '';
  
      for (let i = 0; i < activeTaskTemp?.length; i++) {
        const dep = activeTaskTemp[i].dependencyTask;
       const dependencyParts = typeof dep === 'string' ? dep.split('|') : [];
        const dependencyTask = dependencyParts[1] !== 'undefined' && dependencyParts[1] !== undefined ? dependencyParts[1]: '';
        if (activeTaskTemp[i].isActive === true) {
          if(i===0){
            activeTaskTemp[i].isParallel = true;
          }
          if (activeTaskTemp[i].isParallel === true && (dependencyTask=== '' )) {
            activeTaskTemp[i].isCurrentTask = true;
            tempCurrentTaskData.push(activeTaskTemp[i].taskName);
            const subtaskDetail = activeTaskTemp[i].subTasks;
            for (let j = 0; j < subtaskDetail?.length; j++) {
              if (subtaskDetail[j].isActive === true && j===0) {
                subtaskDetail[j].isCurrentSubtask = true;
                tempCurrentSubTaskData.push(subtaskDetail[j].subTaskName);
                break;
              }
            }
          }
        }
      }
      tempCurrentTaskData.unshift(firstTask);
      tempCurrentSubTaskData.unshift(firstSubTask);
  
      setCurrentTaskDetails({
        currentTask: tempCurrentTaskData.filter(Boolean).join(',') || 'NA',
        currentSubTask: tempCurrentSubTaskData.filter(Boolean).join(',') || 'NA',
        activeTaskCount: activeTaskTemp.length,
    });    
  
      updateCreateOrderTemplate(selectedTemplate);
    }else{
      const activeTaskTemp = selectedTemplate?.tasks?.filter(
        (t: TemplateTask) => t.isActive === true,
      );
      const activeSubTaskTemp = activeTaskTemp?.[0].subTasks?.filter(
        (st: TemplateSubTaskType | TemplateSubTasks) => st.isActive === true,
      );
      setCurrentTaskDetails({
        currentTask: activeTaskTemp?.[0].taskName || 'NA',
        currentSubTask: activeSubTaskTemp?.[0]?.subTaskName || 'NA',
        activeTaskCount: activeTaskTemp.length,
      });
      updateCreateOrderTemplate(selectedTemplate);
    }
    }
    // eslint-disable-next-line
  }, [selectedTemplate]);

  useEffect(() => {
    async function addItems() {
      let itemCount = 0;
  
      await addItemGroupAcquisition(itemGroupsNFAI, {
        customer: userStore.user?.customerName || '',
      })
        .then(async (itemGroupResponse) => {
          itemGroupResponse?.forEach(async (ig: addItemGroupRes, igIndex: number) => {
            const generatedID = uuid();
            const generatedTitle = ig.itemGroupName;
            let tempMeta: any[] = [];
            await WorkflowMetadataHandler(registerScanned.elementId).then(
              (Response) => {
                const keysOfMeta = Object.keys(metadataFromExcel);
                let eleVal = '';
                tempMeta = Response?.map((_data: any) => {
                  const headerVal = _data.elementName.toLowerCase().trim();
                  if (
                    keysOfMeta.includes(headerVal) &&
                    metadataFromExcel[headerVal]?.arr[igIndex]
                  ) {
                    eleVal = metadataFromExcel[headerVal]?.arr[igIndex];
                  } else {
                    eleVal = _data.elementValue || '';
                  }
                  return {
                    ..._data,
                    elementId: uuid(),
                    elementValue: eleVal,
                    options: _data.options?.map((opt: any) => {
                      return {
                        ...opt,
                        optionId: uuid(),
                      };
                    }),
                  };
                });
              },
            );
  
            const receivingWF = { ...dashboard.CreateOrderTemplate };
            if (receivingWF) {
              receivingWF.templateId = uuid();
              receivingWF.isActive = true;
              receivingWF.isDeleted = false;
              receivingWF.tasks?.forEach((task: any, index: number) => {
                task.taskId = uuid();
                if (index === 0 || task.isParallel) {
                  task.isCurrentTask = true;
                } else {
                  task.isCurrentTask = false;
                }
                task?.subTasks?.forEach((subtask: any, stIndex: number) => {
                  subtask.subTaskId = uuid();
                  if (task.isCurrentTask && (stIndex === 0 || subtask.isParallelsubtask)) {
                    subtask.isCurrentSubtask = true;
                  } else {
                    subtask.isCurrentSubtask = false;
                  }
                  subtask?.communication?.forEach(
                    (communication: Communication) => {
                      communication.id = uuid();
                    },
                  );
                  subtask?.api?.forEach((tempApi: tempApi) => {
                    tempApi.id = uuid();
                  });
                  subtask?.elements?.forEach((element: WorkflowElement) => {
                    element.elementId = uuid();
                    element?.options?.forEach((options: WorkflowOptions) => {
                      options.optionId = uuid();
                    });
                    element?.files?.forEach((File: FileUploadInterface) => {
                      File.id = uuid();
                    });
                    element?.photos?.forEach(
                      (photos: FileUploadInterface) => {
                        photos.id = uuid();
                      },
                    );
                  });
                });
              });
            }
            const generatedOrders = [
              {
                orderId: uuid(),
                orderDateTime: new Date().toISOString(),
                username: user?.displayName,
                customerId: user?.customerName,
                departmentId: registerScanned?.departmentId,
                templateId: registerScanned?.templateId,
                isActive: true,
                isDeleted: false,
                isReceiving: true,
                isDelivery: false,
                isReturn: false,
                itemOrderReceiving: [
                  {
                    id: uuid(),
                    customerId: user?.customerName,
                    departmentId: registerScanned?.departmentId,
                    receivingId: '',
                    isActive: true,
                    isDeleted: false,
                    receivingWorkflows: [receivingWF],
                  },
                ],
              },
            ];
            const AssignUsers = NFAIReportRoleBasedUserList
            ?.filter((x) => x.roleName !== 'Operator')
            ?.flatMap((x) => 
              x.userDetails.map((user:any) => ({
                appUserId: user.id,
                itemLevelId: generatedID,
                isHost: true,
              }))
            );         
            const currentYear = new Date().getFullYear();
             const bitDepth = tempMeta.find(item => item.elementName === "Bit Depth")?.elementValue;
            const resolution = tempMeta.find(item => item.elementName === "Resolution")?.elementValue;
            const totalFrame = tempMeta.find(item => item.elementName === "Scanned Frames")?.elementValue || '';
            let SingleFrameSize = ''
            if (bitDepth && resolution) {
              // Lookup table with readonly keys
              const sizeLookup = {
                "10_4K": 56.5,
                "10_2K": 14.1,
                "16_4K": 85.5,
                "16_2K": 21.3
              } as const;

              // Create type-safe union of keys
              type SizeKey = keyof typeof sizeLookup;

              // Construct the key
              const key = `${bitDepth}_${resolution}` as string;

              // Check if key exists in sizeLookup
              if (key in sizeLookup) {
                const size = sizeLookup[key as SizeKey];
                SingleFrameSize = size.toString();
              } else {
                console.log(`No size found for bitDepth: ${bitDepth} and resolution: ${resolution}`);
              }
            }

            const item = {
              id: generatedID,
              title: generatedTitle,
              departmentId: registerScanned?.departmentId,
              departmentName: registerScanned?.departmentName,
              typeid: registerScanned?.typeId,
              type: registerScanned?.typeName,
              elementtypeid: registerScanned?.elementId,
              element: registerScanned?.elementName,
              asset_tracking_status: 'Receiving Order Created',
              asset_In_Vault: 'NFAI - PCPL(S01): INSIDE',
              order_tracking: '',
              physical_sensor_barcode: generatedID,
              physical_sensor_RFID: generatedID,
              physical_sensor_qrcode: generatedID,
              physical_location_rack: 'R02_S01',
              physical_location_shelf: 'S01',
              physical_location_vault: 'PCPL',
              global_positioning_system: '13.054845222199111, 80.20399868485933',
              parent: '',
              receivingdate: new Date().toISOString(),
              itemCreatedAt: new Date().toISOString(),
              last_modified: new Date().toISOString(),
              movementdate: new Date().toISOString(),
              maintenance: new Date().toISOString(),
              status_Time: new Date().toISOString(),
              assignedUsers: commonStore.NFAIReportCustomer ? AssignUsers : [
                {
                  appUserId: user?.id,
                  itemLevelId: generatedID,
                  isHost: true,
                },

              ],
              itemHistory: [
                {
                  id: uuid(),
                  itemId: generatedID,
                  appUserId: user?.id,
                  username: user?.displayName,
                  dateTime: new Date().toISOString(),
                  url: user?.image,
                  status: `User ${user?.displayName!} created "${generatedTitle}" through Batch Upload under New Acquisition.`,
                },
              ],
              isReceivingOrder: true,
              isReceiving: true,
              isDelivery: false,
              isDeleted: false,
              isActive: true,
              status: 'Yet to Start',
              current_task: currentTaskDetails.currentTask,
              current_subtask: currentTaskDetails.currentSubTask,
              current_user: user?.customerName,
              itemCreatedBy: user?.customerName,
              metadata: tempMeta.map(e => ({
                      ...e,
                      elementValue:
                        e.elementType === 'DropDown' && e.options.length !== 0
                          ? e.options.find((option: any) => option.isSelected === true)?.optionName || e.elementValue || ''
                          : e.elementName === 'Restoration Software used'
                            ? 'Diamant'
                            : e.elementName === 'Age of the film'
                              ? currentYear - parseInt(tempMeta?.find(el => el.elementName === 'Film_Year')?.elementValue.toString() || '')
                               : e.elementName === 'Single Frame Size'
                              ? SingleFrameSize
                               : e.elementName === 'Total Frames'
                                ? totalFrame || ''
                                 : e.elementName === 'Aspect Ratio'
                                 ? '1.33'
                            : e.elementValue
                    })),
              orders: generatedOrders || [],
            };
            await createItemAcquisition(item, {
              itemGroupId: ig.itemGroupId,
              title: receivingTitle,
            }).then(async ()=>{
              const stateUpdate = async() => {
                runInAction(() => {
                  dashboard.valueForL3Inventory = '';
                });
                await  setNFAILoader(false)
                await updateDashboardCountNFAI({
                  itemCount,
                  taskCount: currentTaskDetails.activeTaskCount,
                });
                dashboard.inventoryCount += itemCount;
                dashboard.prodCount += itemCount;
                dashboard.taskTotal += itemCount * currentTaskDetails.activeTaskCount;
                commonStore.NFAIReportCustomer
                ? await agent.NFAI.GetFilteredItemDetailscount(initialPostFilteredItemDetails)
                : await agent.updateCountOrder.updateCount(user?.id)
              }
              if(itemGroupResponse.length === igIndex+1) await stateUpdate();
            })
          });
          itemCount = itemGroupResponse?.length || 0;
        })

    }
  
    if (
      dashboard.CreateOrderTemplate?.templateId !== '' &&
      itemGroupsNFAI?.length > 0 &&
      currentTaskDetails.currentTask !== ''
      && NFIACondition
    ) {
      setNFAILoader(true);
      addItems();
    }
    // eslint-disable-next-line
  }, [itemGroupsNFAI, dashboard.CreateOrderTemplate, currentTaskDetails]);
  
  

  const handleSubmit = async (values: ReceivingDelivery) => {
    setNFIACondition(true)
    loadReceivingDelivery(values.id);
    if (values.id === '') {
      // vault id is null for creating vault
      const customerNameData = userStore.user?.customerName;
      const generatedId = uuid();
      const newReceivingDeliveryData = {
        ...values,
        courier: values.mode_of_transport,
        courier_Number: values.mode_of_transport_number,
        date: finalSaveEditDate,
        files: dashboard.camImageUrl,
        id: generatedId,
        customer_Name: customerNameData !== undefined ? customerNameData : '',
      };
      if (devEnv) {
        dashboard.updateLocalFileAPI?.forEach((f: LocalUploadInterface) => {
          setTimeout(() => {
            agent.Files.updateLocalFileUpload(
              f.item,
              generatedId,
              encodeURI(f.path),
            );
          }, 700);
        });
      }
      const registerPayload = {
        registerId: generatedId,
        // title: newReceivingDeliveryData.receivingTitle,
        customer: newReceivingDeliveryData.customer_Name,
        // path: csvPath,
      };

      if (user?.customerName === 'NFAIReport') {
        const response = await registerScanData(registerPayload);
        await loadTemplateIdForCR(response?.templateId || '');
      }

      createReceivingDelivery(newReceivingDeliveryData);
      sendRespectiveEmail(
        'Notification',
        newReceivingDeliveryData.receivingTitle,
        'Created Register Record',
        '',
        ` ${newReceivingDeliveryData.type} is registered successfully on`,
      );

      //email Function
      // setting the state to initial value for form reset
      setcreateNewReceivingDelivery(ReceivingDeliveryInitialdata);
      if(!commonStore.NFAIReportCustomer) await agent.updateCountOrder.updateCount(userStore?.user?.id || '');
      dashboard.checkClikedWorkLevel.title =
        newReceivingDeliveryData.receivingTitle;
      // setting value  which register is for  verify

      setRegisterUrlResponse([]);
      setCamImage([]);
      setcamImageBase64([]);
      dashboard.updateLocalFileAPI = [];
      dashboard.setRegisterPageNumber = 1;
    } else {
      const newArr = {
        ...values,
        date: finalSaveEditDate,
        files: dashboard.camImageUrl,
      };
      updateReceivingDelivery(newArr, 'FromReceiving');
      sendRespectiveEmail(
        'edited',
        newArr.receivingTitle,
        'Edited Register Record',
        '',
      ); //email Function
      // setting the state to initial value for form reset
      setTimeout(() => {
        setcreateNewReceivingDelivery(ReceivingDeliveryInitialdata);
        setRegisterUrlResponse([]);
        setCamImage([]);
        setcamImageBase64([]);
      }, 1000);
      setDisaptchCalled(true);
      modalStore.closeModal();
    }
    dashboard.onFirstLoadNoTransition = false;
    // fade out
    dashboard.setfadeIn = false;
    // setvalues automatically
   if( user?.customerName !== 'NFAIReport' && !NFAILoder)  dashboard.valueForL3Inventory = 'Verify';
    setTimeout(() => {
      // set this inside function in dashboard store
      dashboard.setfadeIn = true;
      loadReceivingsDeliveriesPagination(1);
      updateCountOrderMenu(userStore?.user?.id,commonStore.NFAIReportCustomer);
    }, 1000);

    setcreateNewReceivingDelivery(ReceivingDeliveryInitialdata);
    setRegisterUrlResponse([]);
    setcamImageBase64([]);
    setCamImage([]);
    // setRecevindDeliveryAsUndefined();
   if(!commonStore.NFAIReportCustomer) agent.updateCountOrder.updateCount(userStore?.user?.id || '');
  setNFIACondition(false)
  };

  const handleCancel = () => {
    setcreateNewReceivingDelivery(ReceivingDeliveryInitialdata);
    modalStore.closeModal();
    setRecevindDeliveryAsUndefined();
    setRegisterUrlResponse([]);
    setCamImage([]);
    setcamImageBase64([]);
  };

  const sampleImageArray = [
    '/assets/thumbnail.png',
    '/assets/thumbnail.png',
    '/assets/thumbnail.png',
  ];
  const handleDeleteImage = (url: FileUploadInterface) => {
    if (devEnv) {
      // const splitPath: string[] = url?.url?.split("build") || [];
      agent.Files.deleteLocalFile(url?.url);
      dashboard.updateLocalFileAPI = dashboard.updateLocalFileAPI?.filter(
        (x) => x.id !== url.id,
      );
    }
    deleteFile(url.fileId);
    const filterdata = dashboard.camImageUrl.filter((x) => x.id !== url.id);
    setRegisterUrlResponse(filterdata);
    setCamImage(filterdata);
  };

  const closeCamera = () => {
    setCameraOpen(false);
  };

  const openCameraModal = (title: string) => {
    setReceivingTitle(title);
    setOpenCameraModal(true);
    setCameraOpen(true);
  };

  const readCSV = (myNewFile: File) => {
    Papa.parse(myNewFile, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        let keyVal = '';
        let obj: any = {};
        let objKeys: string[] = [];
        let tempItemGroups: string[] = [];
        results.data.forEach((d: any) => {
          const myKeys = Object.keys(d);
          const myValues = Object.values(d);
          if (myValues.includes('Film_Title')) {
            const indexx = myValues.indexOf('Film_Title');
            keyVal = myKeys[indexx];
            myValues?.forEach((v: any, index: number) => {
              if (v !== '') {
                let tempV = v.toLowerCase().replace(/\n/g, ' ').trim();
                obj[tempV] = {
                  key: myKeys[index],
                  arr: [],
                };
              }
            });
            objKeys = Object.keys(obj);
          }
          if (keyVal !== '') {
            tempItemGroups.push(d[keyVal]);
          }
          Object.entries(obj)?.forEach(([obKey, obVal]: any) => {
            if (
              myKeys.includes(obVal.key) &&
              !objKeys.includes(
                d[obVal.key].toLowerCase().replace(/\n/g, ' ').trim(),
              )
            ) {
              obj[obKey] = {
                ...obVal,
                arr: [...obVal.arr, d[obVal.key]],
              };
            }
          });
        });
        tempItemGroups = tempItemGroups.slice(1);
        setItemGroupsNFAI(tempItemGroups);
        setMetadataFromExcel(obj);
      },
    });
  };

  const handleCSVFileUpload = async (event: any, title: string) => {
    let myNewFile: File;
    setReceivingTitle(title);
    const myFile = event.target.files[0];
    if (!['xls', 'xlsx', 'csv'].includes(myFile.name.split('.')?.[1])) {
      setCsvDataErr('Kindly upload Excel document');
    } else {
      myNewFile = new File([myFile], `${title}.csv`);
      if (['xls', 'xlsx'].includes(myFile.name.split('.')?.[1])) {
        const reader = new FileReader();
        // setCsvDataErr('Kindly upload Excel document');
        reader.onload = async (e: any) => {
          const data = new Uint8Array(e.target.result);
          const workbook = read(data, { type: 'array' });
          const workBookLength = workbook.SheetNames.length;
          for (var k = 0; k < workBookLength; k++) {
            const sheetName = workbook.SheetNames[k];
            const sheet = workbook.Sheets[sheetName];
            var rows = utils.sheet_to_json(sheet, {
              blankrows: false,
              header: 'A',
              raw: true,
              rawNumbers: true,
            });
            const items: any[] = rows;
            const replacer = (key: any, value: null) =>
              value === null ? '' : value; // specify how you want to handle null values here
            const myCSVarray: string[] = [];
            let csv: any = '';
            items.forEach((row) => {
              myCSVarray.push(JSON.stringify(row['A'], replacer));
            });
            myCSVarray.join(',');
            csv = myCSVarray.join('\r\n');
            let csvContent = 'data:text/csv;charset=utf-8,' + csv;
            var encodedUri = encodeURI(csvContent);
            var byteString;
            if (encodedUri.split(',')[0].indexOf('base64') >= 0)
              byteString = atob(encodedUri.split(',')[1]);
            else byteString = unescape(encodedUri.split(',')[1]);
            // separate out the mime component
            // var mimeString = encodedUri.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            myNewFile = new File([ia], `${title}.csv`);
            setCsvDataErr('');
          }
        };
        reader.readAsArrayBuffer(myFile);
      }
      readCSV(myNewFile);

      // if (devEnv) {
      //   const item = 'NFAI';
      //   const workLevel = title;
      //   response = await agent.Files.localFileUpload(
      //     myNewFile,
      //     workLevel,
      //     item,
      //   );
      //   const url = response.data?.path.replace(/\\\\/g, '\\');
      //   setCsvPath(url);
      // } else {
      //   response = await agent.Files.uploadFile(myNewFile);
      //   setCsvPath(response?.data.url);
      // }
    }
  };

  return (
    <>
       {user?.customerName === 'CG' || user?.customerName === 'Restoration'
       ? ( <Segment clearing className="register-form-segment">

       
                  <TitleCreate />
                  </Segment>
                ):(
      commonStore.filterModeOne?.includes('IRB1') && (
        <Segment clearing className="register-form-segment">
          {dashboard.openCameraModal && openCamera ? (
            <CameraModal
              nameData="receiving"
              workLevelForReceiving={receivingTitle}
            />
          ) : (
            closeCamera
          )}
          <Form clearing style={{ marginTop: '1px' }}>
            <Header
              clearing
              icon="edit"
              size="huge"
              dividing
              as="h1"
              content={
                (
                  userLanguage[0].Level3InventoryRecievingRegister
                    ?.IRRL01 as any
                )?.[`${commonStore.language.key}`]  
              }
              sub
              color="grey"
            />
          </Form>
          {commonStore.hfcCustomerChanges ? (<MultiSectionForm/>) : (
           <Formik
            initialValues={createNewReceivingDelivery}
            enableReinitialize={true}
            onSubmit={(values, { resetForm }) => {
              handleSubmit(values);
              resetForm();
            }}
            validationSchema={Yup.object({
              receivingTitle: Yup.string().required('Please Specify Title'),
              type: Yup.string().required('Please Specify Type'),
              barcode_Package: hfcCustomerChanges
                ? Yup.string().required('Please Specify Print')
                : Yup.string().notRequired(),
              // sender_Details: Yup.string().required("Please Specify Details"),
              // courier_Number:Yup.string().required("Please Specify Courier Number"),
              // courier:Yup.string().required("Please Specify a Courier Name"),
              // receiver_Description:Yup.string().required("Please Specify Receiver Description"),
              // barcode_Package:Yup.string().required("Please Specify Barcode")
            })}
          >
            {({
              handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              values,
              resetForm,
            }) => (
              <Form fluid className="ui form error" autoComplete="off">
                <Header
                  clearing
                  style={{ marginTop: '15px' }}
                  icon="clipboard list"
                  content={
                    (
                      userLanguage[0].Level3InventoryRecievingRegister
                        ?.IRRL02 as any
                    )?.[`${commonStore.language.key}`]
                  }
                  sub
                />

                <Grid stretched columns={3}>
                  <Grid.Column container fluid>
                    <MyTextInput
                      name="receivingTitle"
                      label={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL03 as any
                        )?.[`${commonStore.language.key}`]
                      }
                      placeholder={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL03 as any
                        )?.[`${commonStore.language.key}`]
                      } //"Title"
                      mandatory
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <MyTextInput
                      name="type"
                      label={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRTB02 as any
                        )?.[`${commonStore.language.key}`]
                      }
                      placeholder={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRTB02 as any
                        )?.[`${commonStore.language.key}`]
                      }
                      mandatory
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <MyTextInput
                      name="sender_Details"
                      label={
                        hfcCustomerChanges
                          ? 'Owner'
                          : (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL05 as any
                            )?.[`${commonStore.language.key}`]
                      }
                      placeholder={
                        hfcCustomerChanges
                          ? 'Owner'
                          : (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB03 as any
                            )?.[`${commonStore.language.key}`]
                      }
                    />
                  </Grid.Column>
                </Grid>
                <Grid
                  stretched
                  columns={3}
                  style={
                    user?.customerName === 'CG' || hfcCustomerChanges
                      ? { display: 'none' }
                      : {}
                  }
                >
                  <Grid.Column>
                    <MyTextInput
                      name="mode_of_transport"
                      label={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL06 as any
                        )?.[`${commonStore.language.key}`]
                      } //Mode of Transport
                      placeholder={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRTB04 as any
                        )?.[`${commonStore.language.key}`]
                      } //Mode of Transport
                    />
                  </Grid.Column>
                  <Grid.Column
                    style={hfcCustomerChanges ? { display: 'none' } : {}}
                  >
                    <MyTextInput
                      name="mode_of_transport_number"
                      label={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL07 as any
                        )?.[`${commonStore.language.key}`]
                      } //Mode of Transport Number
                      placeholder={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRTB05 as any
                        )?.[`${commonStore.language.key}`]
                      } //Mode of Transport Number
                    />
                  </Grid.Column>
                  <Grid.Column>
                    {!editDateClicked ? (
                      <Form.Field
                        // name="dateRequestRaised"
                        label={
                          (
                            userLanguage[0].Level3InventoryRecievingRegister
                              ?.IRRL08 as any
                          )?.[`${commonStore.language.key}`]
                        } //Date
                        placeholderText={
                          (
                            userLanguage[0].Level3InventoryRecievingRegister
                              ?.IRRTB06 as any
                          )?.[`${commonStore.language.key}`]
                        } //Date
                        value={dateString}
                        control={Input}
                        onClick={() => setEditDateClicked(true)}
                        Icon="calendar alternate outline"
                        onKeyDown={(event: SyntheticEvent) => {
                          event.preventDefault();
                        }}
                      />
                    ) : (
                      <>
                        <label
                          style={{
                            marginBottom: '5px',
                            color: 'black',
                          }}
                        >
                          <b>Date</b>
                        </label>

                        <input
                          value={dateString}
                          type="date"
                          data-date=""
                          data-date-format="DD MMMM YYYY"
                          onChange={handleDateChange}
                        />
                      </>
                    )}
                  </Grid.Column>
                </Grid>
                <Grid
                  stretched
                  columns={3}
                  style={user?.customerName !== 'CG' ? { display: 'none' } : {}}
                >
                  <Grid.Column>
                    {!editDateClicked ? (
                      <Form.Field
                        // name="dateRequestRaised"
                        label={
                          (
                            userLanguage[0].Level3InventoryRecievingRegister
                              ?.IRRL08 as any
                          )?.[`${commonStore.language.key}`]
                        } //Date
                        placeholderText={
                          (
                            userLanguage[0].Level3InventoryRecievingRegister
                              ?.IRRTB06 as any
                          )?.[`${commonStore.language.key}`]
                        } //Date
                        value={dateString}
                        control={Input}
                        onClick={() => setEditDateClicked(true)}
                        Icon="calendar alternate outline"
                        onKeyDown={(event: SyntheticEvent) => {
                          event.preventDefault();
                        }}
                      />
                    ) : (
                      <>
                        <label
                          style={{
                            marginBottom: '5px',
                            color: 'black',
                          }}
                        >
                          <b>Date</b>
                        </label>

                        <input
                          type="date"
                          data-date=""
                          data-date-format="DD MMMM YYYY"
                          onChange={handleDateChange}
                        />
                      </>
                    )}
                  </Grid.Column>
                </Grid>
                <Grid stretched columns={hfcCustomerChanges ? 3 : 2}>
                  <Grid.Column>
                    <MyTextInput
                      name="receiver_Description"
                      label={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRL09 as any
                        )?.[`${commonStore.language.key}`]
                      } //"Description"
                      placeholder={
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRTB07 as any
                        )?.[`${commonStore.language.key}`]
                      } //"Description"
                    />
                  </Grid.Column>
                  <Grid.Column
                    className={
                      user?.customerName === 'CG'
                        ? 'ReceivingBarcode_Package'
                        : ''
                    }
                  >
                    <MyTextInput
                      name="barcode_Package"
                      label={
                        hfcCustomerChanges
                          ? 'Print'
                          : (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRL10 as any
                            )?.[`${commonStore.language.key}`]
                      } //"Barcode Package"
                      placeholder={
                        hfcCustomerChanges
                          ? 'Print'
                          : (
                              userLanguage[0].Level3InventoryRecievingRegister
                                ?.IRRTB08 as any
                            )?.[`${commonStore.language.key}`]
                      } //"Barcode Package"
                      mandatory={hfcCustomerChanges}
                    />
                  </Grid.Column>
                </Grid>
                {user?.customerName !== 'CG' ? (
                  <Header
                    icon="camera"
                    content={
                      (
                        userLanguage[0].Level3InventoryRecievingRegister
                          ?.IRRL12 as any
                      )?.[`${commonStore.language.key}`]
                    } //"Photographs of Package "
                    sub
                  />
                ) : (
                  ''
                )}
                {user?.customerName !== 'CG' ? (
                  <Header
                    clearing
                    style={{ marginBottom: '10px' }}
                    icon="image"
                    content={
                      (
                        userLanguage[0].Level3InventoryRecievingRegister
                          ?.IRRL13 as any
                      )?.[`${commonStore.language.key}`]
                    } //"Package Views"
                    sub
                  />
                ) : (
                  ''
                )}

                {user?.customerName !== 'CG' ? (
                  <Segment>
                    <Grid>
                      {camImage.length !== 0
                        ? camImage.map((url) => {
                            return (
                              <Grid.Column
                                textAlign={'center'}
                                key={url.id}
                                width={2}
                              >
                                <ImageTag
                                  imageUrl={url.url}
                                  defaultUrl="/assets/documents.jpg"
                                  label={{
                                    as: 'a',
                                    corner: 'right',
                                    icon: 'x',
                                    size: 'tiny',
                                  }}
                                  handleClick={() => handleDeleteImage(url)}
                                />
                              </Grid.Column>
                            );
                          })
                        : sampleImageArray.map((e, i) => {
                            return (
                              <Image
                                size="small"
                                src={e}
                                alt="/assets/documents.jpg"
                              />
                            );
                          })}
                    </Grid>
                  </Segment>
                ) : (
                  ''
                )}
                <div>
                  <Header />
                  {user?.customerName !== 'CG' && (
                  <Button
                    positive
                    floated="right"
                    className={
                      hfcCustomerChanges ? 'ReceivingBarcode_Package' : ''
                    }
                    onClick={() =>
                      modalStore.openSmallModal(
                        <>
                          <PackageReceiptPrintView
                            printViewvalues={values}
                            printViewImg={dashboard.camImageUrl}
                            PrintViewDate={dateString}
                          />
                        </>,
                      )
                    }      
                    //Print Receipt
                  >
                    <Icon name="print" size="large" />
                    {
                      (
                        userLanguage[0].Level3InventoryRecievingRegister
                          ?.IRRB02 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </Button>
                  )}
                  {user?.customerName !== 'CG' ? (
                    <Button
                      primary
                      floated="right"
                      onClick={() => openCameraModal(values.receivingTitle)}
                      disabled={
                        !(values.receivingTitle !== '' && values.type !== '')
                      }
                      //Add Photographs
                    >
                      <Icon name="camera retro" size="large" />
                      {
                        (
                          userLanguage[0].Level3InventoryRecievingRegister
                            ?.IRRB01 as any
                        )?.[`${commonStore.language.key}`]
                      }
                    </Button>
                  ) : (
                    ' '
                  )}
                </div>
                {userStore.user?.customerName === 'NFAIReport' && (
                  <div>
                    <Input
                      type="file"
                      disabled={values.receivingTitle === ''}
                      onChange={(_e) =>
                        handleCSVFileUpload(_e, values.receivingTitle)
                      }
                    />
                    <p style={{ marginTop: '8px' }}>{csvDataErr}</p>
                  </div>
                )}
               
                <Button.Group style={{ marginTop: '40px' }}>
                  <Button
                    onClick={() => {
                      resetForm();
                      handleCancel();
                    }}
                    //Cancel
                  >
                    {' '}
                    {
                      (
                        userLanguage[0].Level3InventoryRecievingRegister
                          ?.IRRB03 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </Button>
                  <Button.Or
                    text={
                      (
                        userLanguage[0].Level3InventoryRecievingRegister
                          ?.IRRB04 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  />             
                  <Button
                    disabled={(commonStore.NFAIReportCustomer
                       && (values.receivingTitle === ''
                       || values.type === '')) ? true : false}
                    // disabled={errorType.length<1||isSubmitting}
                    loading={user?.customerName === 'NFAIReport' ? NFAILoder : isSubmitting}
                    onClick={() => handleSubmit()}
                    content="Submit"
                    positive
                    //Submit
                  >
                    {
                      (
                        userLanguage[0].Level3InventoryRecievingRegister
                          ?.IRRB05 as any
                      )?.[`${commonStore.language.key}`]
                    }{' '}
                  </Button>
                </Button.Group>
              </Form>
            )}
          </Formik>)}       
        </Segment>)
     )}
    </>
  );
}
export default observer(DashboardReceivingDeliveryForm);
